import { Box, Button, Title } from '@factorialco/deprecated-design-system'

import { BoxList } from 'modules/core/components/BoxList'

import EmptyList from 'modules/documents/components/DocumentTemplates/Content/DocumentTemplatesList/EmptyList'
import Item from 'modules/documents/components/DocumentTemplates/Content/DocumentTemplatesList/Item'
import { DocumentTemplate } from 'modules/documents/hooks/useGetDocumentTemplates'
import type { TaskConfigurationSendDocumentTemplate } from 'modules/processes/hooks/useTaskConfigurationSendDocumentTemplate'

interface AddButtonProps {
  label: string
  onClick: () => void
}

interface Props {
  templates: DocumentTemplate[]
  taskConfigurations: TaskConfigurationSendDocumentTemplate[]
  title: string
  addButton?: AddButtonProps
  showEmptyList?: boolean
}

const TemplateList = ({
  templates,
  taskConfigurations,
  title,
  addButton,
  showEmptyList,
}: Props) => {
  if (!showEmptyList && templates.length === 0) return null

  return (
    <>
      <Box
        paddingTop="s24"
        paddingBottom="s6"
        width="full"
        flexDirection="row"
        justifyContent="spaceBetween"
      >
        <Title title={title} variant="400" />
        {addButton && (
          <Button type="secondary" onClick={addButton?.onClick} iconName="add">
            {addButton?.label}
          </Button>
        )}
      </Box>
      {showEmptyList && templates.length === 0 && <EmptyList />}
      {templates.length > 0 && (
        <BoxList>
          {templates.map((documentTemplate) => {
            const itemTaskConfigurations = taskConfigurations.filter(
              (element) => element.documentTemplateId === documentTemplate.id
            )

            return (
              <Item
                key={documentTemplate.id}
                documentTemplate={documentTemplate}
                taskConfigurations={itemTaskConfigurations}
              />
            )
          })}
        </BoxList>
      )}
    </>
  )
}

export default TemplateList
